import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Store } from '@sama/app-state';
import { DirectiveSuperclass } from '@sama/ng-core';
import { combineLatest } from 'rxjs';
import { getOutputHelper } from '../../../../../shared/output-helpers/get-output-helper';
import { shellConnectorToken } from '../../../../../team-apis/core/shell-connector';
import { AbstractSensorContentStore2D } from '../../../state/abstract-sensor-content-store-2d';

@Component({
  selector: 'h3-zoom-panel-settings',
  templateUrl: './zoom-panel-settings.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ZoomPanelSettingsComponent extends DirectiveSuperclass {
  altImageEnabledStore!: Store<boolean>;
  zoomPanelEnabledStore!: Store<boolean>;
  shouldDisplayZoomPanelSettings!: boolean;
  shouldDisplayAltImageSetting!: boolean;

  constructor() {
    super();

    const store = inject(AbstractSensorContentStore2D);
    const shellConnector = inject(shellConnectorToken);

    this.zoomPanelEnabledStore = store('layerSettings')('zoomPanelEnabled');
    this.altImageEnabledStore = store('layerSettings')('altImageEnabled');

    this.subscribeTo(
      combineLatest([
        store('layerSettings')('zoomPanelScale').$,
        this.zoomPanelEnabledStore.$,
      ]),
      ([scale, enabled]) => shellConnector.setZoomPanelSettings(scale, enabled),
    );

    const output = store.state().output;
    this.shouldDisplayZoomPanelSettings = !getOutputHelper(
      output.type,
    ).isOrthographicProjection(output);
    this.shouldDisplayAltImageSetting =
      shellConnector.hasFeatureFlag('alt-image-setting');
  }
}
